import type { FormKitNode } from '@formkit/core'
import { isValidPhoneNumber, type CountryCode } from 'libphonenumber-js/max'

export default (node: FormKitNode, country: CountryCode = 'PL'): boolean => {
  return typeof node.value === 'string' && isValidPhoneNumber(node.value, country)
}